import { Button, HStack, useToast } from '@chakra-ui/react';
import { Icon } from '@common/components/Icon';
import { usePropertiesModel } from '@common/models/PropertiesModel';
import { FontFamily } from '@common/theming/Fonts';
import React from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from 'src/apps/invest/config';

type NavigationProps = {
  children?: React.ReactNode;
};

export const Navigation: React.FC<NavigationProps> = () => {
  const { property } = usePropertiesModel();
  const toast = useToast();

  async function handleShare() {
    try {
      await navigator.share({
        text: property?.display_name ?? undefined,
        title: 'Checkout this Concreit property!',
        url: window.location.href,
      });
    } catch (err) {
      await navigator.clipboard.writeText(window.location.href);
      toast({
        description: `A link to this property (${property?.display_name}) has been copied to your clipboard. Please share it via text, email, etc...`,
        duration: 5000,
        isClosable: true,
        position: 'top',
        status: 'info',
        title: `Link copied to clipboard`,
      });
    }
  }

  return (
    <HStack justifyContent={'space-between'} mb={['0px', '20px']}>
      <Button
        as={Link}
        color="black"
        to={ROUTES.properties}
        fontFamily={FontFamily.HELVETICA_NOW_BOLD}
        fontWeight={'normal'}
        fontSize={['16px', '20px']}
        variant="ghost"
        leftIcon={<Icon icon="arrow-left-long" boxSize="16px" variant="regular" />}>
        Back
      </Button>
      <Button
        color="black"
        onClick={handleShare}
        variant="ghost"
        fontFamily={FontFamily.HELVETICA_NOW_BOLD}
        fontWeight={'normal'}
        fontSize={['16px', '20px']}
        leftIcon={<Icon icon="arrow-up-from-bracket" boxSize="16px" variant="regular" />}>
        Share
      </Button>
    </HStack>
  );
};
